import CloseButton from './closeButton.component';

export default CloseButton;
